import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Jungle,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const JungleEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Jungle),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type JungleEntity = InferOutput<typeof JungleEntitySchema>

/**
 * Lush, dense tropical forest with high biodiversity and thick vegetation.
 */
export const JungleEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Jungle,
  dname: 'Jungle',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 2,
  blocksVision: true,
  entDefaults,
}

export function createJungleEntity(id: number, x: number, y: number): JungleEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
